var _defs, _circle, _path, _path2, _circle2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChemThermo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ChemSenseThermocouple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 100.33,
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.64,109.5a7.5,7.5,0,0,1-6.06-11.91C30.63,78.25,68.06,26.5,72.38,19.4,80.49,6.07,89.7,3.27,96,3.27h94.12a7.5,7.5,0,0,1,0,15H96c-4.43,0-8.32,4.85-10.79,8.92-5.53,9.09-54.41,76.36-56.49,79.22A7.47,7.47,0,0,1,22.64,109.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.11,198.07H96c-6.29,0-15.5-2.8-23.61-16.13-4.32-7.11-41.75-58.86-55.8-78.2a7.5,7.5,0,0,1,12.13-8.82c2.08,2.86,51,70.14,56.48,79.22,2.48,4.07,6.37,8.93,10.8,8.93h94.12a7.5,7.5,0,0,1,0,15Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 138.1,
    cy: 144.78,
    r: 23.78
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.29,
    y: 30.71,
    width: 17.62,
    height: 134.79,
    rx: 8.81
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemThermo);
export default __webpack_public_path__ + "static/media/ChemThermo.fe691fcf29a73810dcd0eff7949ee426.svg";
export { ForwardRef as ReactComponent };